import { hashInput } from './hashUtils';

/**
 * @function isApiAvailable
 *
 * @description
 * Returns whether or not DY API is available
 *
 * @returns {Boolean} True/False if DY API exists on window object
 */
export function isApiAvailable() {
    return _.has(window, 'DY.API');
}

/**
 * @function fireDYEvent
 *
 * @description
 * Notifies Dynamic Yield of a new event
 *
 * @param {String} event Event to be sent to Dynamic Yield
 * @param {String} email Email address of user associated with event
 * @param {Boolean} retry Whether or not to retry firing the event if DY API is missing
 * @returns {Boolean} True/False for if event was fired or not
 */
export function fireDYEvent(event, email, retry = true) {
    const hashedEmail = email ? hashInput(email.toLowerCase()) : '';

    const nameObj = {
        'signup': 'Signup',
        'login': 'Login',
        'newsletter': 'Newsletter Subscription'
    };

    const dyTypeObj = {
        'signup': 'signup-v1',
        'login': 'login-v1',
        'newsletter': 'newsletter-subscription-v1'
    };

    // If the DY API doesn't exist on the first attempt, try once, and only once, more 500ms later
    if (!isApiAvailable()) {
        if (retry) {
            setTimeout(() => {fireDYEvent(event, email, false);}, 500);
        }
        return false;
    }

    DY.API('event', {
        name: nameObj[event],
        properties: {
            dyType: dyTypeObj[event],
            hashedEmail: hashedEmail
        }
    });

    return true;
}
